import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TechniciansTabPageView } from './TechniciansTabPageView';

export function TechniciansTabPageContainer() {
  const { orgId } = useParams<{ orgId: string }>();
  const { t } = useTranslation('organization');

  return <TechniciansTabPageView title={t('technicians.title', { orgId })} />;
}
